export const ERROR_TOAST_AUTO_CLOSE_TIME = 5000;
